import { render, staticRenderFns } from "./PopupComponent.vue?vue&type=template&id=2a4dbbc0"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports